import useT from './useTranslation'

function useTranslatedArray(array) {
	if (!Array.isArray(array)) return []
	return array.map((text) => useT(text) || '')
}

export default useTranslatedArray
